module.exports = __webpack_public_path__ + "reservation.jpg?40e7a9ef4052cfe9901b7d4cfedf840a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/reservation.jpg
// module id = 53
// module chunks = 0